export default "__VITE_ASSET__CvbVtKAl__"